import { Button, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Step, Stepper, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAutoMatchProfile extends Layout {
    buttonComments: Button;
    buttonOrderFields: Button;
    buttonRequiredEquipment: Button;
    horizontalspacer10: HorizontalSpacer;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    horizontalspacer8: HorizontalSpacer;
    horizontalspacer9: HorizontalSpacer;
    imageCommodityCheck: Image;
    imageConsigneeCheck: Image;
    imageCustomerCheck: Image;
    imageLocationCheck: Image;
    imageOrderModeCheck: Image;
    imageOrderTypeCheck: Image;
    imageRevenueCodeCheck: Image;
    imageShipperCheck: Image;
    imageTrailerTypeCheck: Image;
    labelA: Label;
    labelAutoPopulatedFieldsSummary: Label;
    labelCommentsSummary: Label;
    labelCommodity: Label;
    labelConsigneeLocation: Label;
    labelCustomer: Label;
    labelDescription10: Label;
    labelDescription1: Label;
    labelDescription2: Label;
    labelDescription3: Label;
    labelDescription4: Label;
    labelDescription6: Label;
    labelDescription8: Label;
    labelE: Label;
    labelLocation: Label;
    labelOrderFieldName: Label;
    labelOrderMode: Label;
    labelOrderType: Label;
    labelPreFilledValues: Label;
    labelRequiredEquipmentSummary: Label;
    labelRevenueCodeId: Label;
    labelS: Label;
    labelTrailerType: Label;
    labelValue: Label;
    layoutAutoMatchProfileQualifiersStep2: Layout;
    layoutAutoMatchProfileQualifiersStep3: Layout;
    layoutAutoMatchProfileQualifiersStep4: Layout;
    layoutAutoMatchProfileQualifiersStep5: Layout;
    panelAddComments: Panel;
    panelAutoPopulatedFields: Panel;
    panelAutoPopulatedFieldsSummary: Panel;
    panelCommentsReview: Panel;
    panelEquipmentMatch: Panel;
    panelEquipmentMatchSummary: Panel;
    panelPreFilledValues: Panel;
    panelPreFilledValuesContent: Panel;
    panelQualifiers: Panel;
    panelSelectQualifiersHeader: Panel;
    panelStepToggles: Panel;
    sourceComments: DataSource;
    sourceEquipMatchDetail: DataSource;
    sourceEquipmentMatch: DataSource;
    sourceEquipmentMatchDefault: DataSource;
    stepAutoPopulatedFields: Step;
    stepComments: Step;
    stepQualifiers: Step;
    stepRequiredEquipment: Step;
    stepReviewAndComplete: Step;
    stepperAutoMatchProfile: Stepper;
    switchActive: Switch;
    tableAutoPopulatedFields: Table;
    tableAutoPopulatedFieldsSummary: Table;
    tableComments: Table;
    tableCommentsSummary: Table;
    tableRequiredEquipment: Table;
    tableRequiredEquipmentSummary: Table;
    textboxCommodityId: Textbox;
    textboxConsigneeLocationId: Textbox;
    textboxCustomerId: Textbox;
    textboxLocationId: Textbox;
    textboxName: Textbox;
    textboxOrderMode: Textbox;
    textboxOrderTypeId: Textbox;
    textboxPriority: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxShipperLocationId: Textbox;
    textboxTrailerMatch: Textbox;
}
